import { IsOptional, IsString, IsDateString, MaxLength } from 'class-validator';

export class CreateDocumentApprovalRequestDto {
    /**
     * Digital signature reference
     * @example 'docusign-envelope-12345'
     */
    @IsOptional()
    @IsString()
    @MaxLength(255)
    signedBy?: string;

    /**
     * Name of the signer
     * @example 'John Doe'
     */
    @IsOptional()
    @IsString()
    @MaxLength(255)
    signerName?: string;

    /**
     * Reason for signing
     * @example 'Approved for implementation'
     */
    @IsOptional()
    @IsString()
    signingReason?: string;

    /**
     * Timestamp of signing (ISO 8601 format)
     * @example '2024-01-15T10:30:00.000Z'
     */
    @IsOptional()
    @IsDateString()
    signingTime?: string;

    /**
     * Hash or ID from DocuSign
     * @example 'ds-envelope-hash-abc123'
     */
    @IsOptional()
    @IsString()
    @MaxLength(255)
    signatureHash?: string;
}
